// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as GeoRegionRepoManager from "./GeoRegionRepoManager.bs.js";

function useGeoRegions(country) {
  var match = React.useState(function () {
        return {
                TAG: /* Loading */0,
                _0: undefined
              };
      });
  var updateGeoRegions = match[1];
  var RepoInstance = GeoRegionRepoManager.getRepo(undefined);
  var $$fetch = function (param) {
    return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._1(RepoInstance.fetchGeoRegions, country);
                }), (function (data) {
                  return Curry._1(updateGeoRegions, (function (param) {
                                return {
                                        TAG: /* Live */1,
                                        _0: data
                                      };
                              }));
                }), (function (error) {
                  return Curry._1(updateGeoRegions, (function (param) {
                                return {
                                        TAG: /* Error */2,
                                        _0: error
                                      };
                              }));
                }));
  };
  React.useEffect((function () {
          $$fetch(undefined);
          
        }), []);
  return match[0];
}

export {
  useGeoRegions ,
  
}
/* react Not a pure module */
